import { isValidNumber } from "libphonenumber-js";

export const fieldEmptyNull = (field: string) => {
  if (field) {
    return field.replace(/\s/g, "").length > 0;
  }
  return false;
};
export const checkEmail = (email: string) => {
  if (email) {
    return !!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
  return false;
};
export const checkIsDefined = (value: any) => {
  return !!(value !== null && value !== undefined);
};
export const checkIntervallContract = (start: string, end: string) => {
  try {
    if (fieldEmptyNull(start) && fieldEmptyNull(end)) {
      const start_contract = new Date(start);
      const end_contract = new Date(end);
      if (start_contract >= end_contract) {
        return false;
      }
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const isValidPhoneNumber = (phone: string): boolean => phone && isValidNumber(phone);

